export default class UUID {
  public getNew(): string {
    const randomId =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
    return randomId;
  }
}
